import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
import { useLocalization } from '~/composables/_next/useLocalization';
import PriceView from '~/components/Product/ProductPrice/PriceView';
import PriceDiscountLabel from '~/components/Product/ProductPrice/PriceDiscountLabel.vue';
import { getNextYearDate } from '@/helpers/formatDate';
import { SCHEMA_OFFER, SCHEMA_PRODUCT_IN_STOCK, SCHEMA_PRODUCT_OOS } from '~/constants';
var priceIntegerWithCommaRegexp = /[0-9,]/g;
export default {
  name: 'Price',
  components: {
    PriceView: PriceView,
    PriceDisplay: PriceDisplay,
    PriceDiscountLabel: PriceDiscountLabel
  },
  props: {
    regular: {
      type: [String, Number],
      default: null
    },
    special: {
      type: [String, Number],
      default: null
    },
    amount: {
      type: [Number, String],
      default: 1
    },
    price: {
      type: Object,
      default: function _default() {}
    },
    isInStock: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(props) {
    var _useLocalization = useLocalization(),
      currency = _useLocalization.currency;
    var getPriceInParts = function getPriceInParts(priceType) {
      var _ref, _ref$toFixed;
      var price = props[priceType];
      if (!price) return null;
      var priceIntegerWithComma = price.match(priceIntegerWithCommaRegexp);
      var splitPrice = priceIntegerWithComma.join('').split(',');
      var priceMultipliedByProductsAmount = (_ref = Number("".concat(splitPrice[0], ".").concat(splitPrice[1])) * props.amount) === null || _ref === void 0 ? void 0 : (_ref$toFixed = _ref.toFixed(2)) === null || _ref$toFixed === void 0 ? void 0 : _ref$toFixed.split('.');
      var totalPart = priceMultipliedByProductsAmount[0];
      var decimalPart = priceMultipliedByProductsAmount[1];
      return {
        totalPart: totalPart,
        decimalPart: decimalPart,
        currencySymbol: price.trim()[price.length - 1]
      };
    };
    var isProductInStock = computed(function () {
      return props.isInStock;
    });
    var regularPrice = computed(function () {
      return getPriceInParts('regular');
    });
    var specialPrice = computed(function () {
      return getPriceInParts('special');
    });
    var formatPrice = function formatPrice(price) {
      var _Number;
      if (!price) return null;
      return (_Number = Number(price.replace(/[^0-9,]/g, '').replace(',', '.'))) === null || _Number === void 0 ? void 0 : _Number.toFixed(2);
    };
    var formattedPriceForSchema = computed(function () {
      var _props$price, _props$price2;
      if (typeof ((_props$price = props.price) === null || _props$price === void 0 ? void 0 : _props$price.special) !== 'number' && typeof ((_props$price2 = props.price) === null || _props$price2 === void 0 ? void 0 : _props$price2.regular) !== 'number') {
        return;
      }
      if (props.price) {
        var _props$price3, _props$price4;
        var _priceValue = props.price.special !== null ? (_props$price3 = props.price) === null || _props$price3 === void 0 ? void 0 : _props$price3.special : (_props$price4 = props.price) === null || _props$price4 === void 0 ? void 0 : _props$price4.regular;
        return _priceValue === null || _priceValue === void 0 ? void 0 : _priceValue.toFixed(2);
      }
      var priceValue = props.special !== null ? props.special : props.regular;
      return formatPrice(priceValue);
    });
    var getCurrency = currency;
    return {
      regularPrice: regularPrice,
      specialPrice: specialPrice,
      getCurrency: getCurrency,
      formattedPriceForSchema: formattedPriceForSchema,
      isProductInStock: isProductInStock,
      SCHEMA_OFFER: SCHEMA_OFFER,
      SCHEMA_PRODUCT_IN_STOCK: SCHEMA_PRODUCT_IN_STOCK,
      SCHEMA_PRODUCT_OOS: SCHEMA_PRODUCT_OOS,
      getNextYearDate: getNextYearDate
    };
  }
};